(function () {
    'use strict';

    angular
        .module('salesflare')
        .controller('UpgradeDialogController', UpgradeDialogController);

    function UpgradeDialogController($scope, $state, $mdDialog, $mdMedia, $window, authentication, model, plansService, sfUpgradeConfirmationDialog, utils, $translate) {

        $scope.$mdMedia = $mdMedia;
        $scope.currency = model.me.team.billing_currency;
        $scope.transitioned = false;
        $scope.subscribedOrNonRestrictedSumo = model.me.team.subscribed || (model.me.team.discount_type === 'firstFreeThen50Off' && !model.me.restricted);
        $scope.currentlyOnPlansPage = ($state.current.name === 'plans');

        const flag = this.flag;

        init();

        $scope.$on('$destroy', function () {

            $window.removeEventListener('focus', focusEventListener);
        });

        $scope.discard = function () {

            return $mdDialog.hide(false);
        };

        $scope.close = function () {

            return $mdDialog.cancel();
        };

        $scope.upgrade = function () {

            if (model.me.is_admin) {
                if ($scope.subscribedOrNonRestrictedSumo) {
                    return sfUpgradeConfirmationDialog.show($scope.upgradePlan)
                        .then($mdDialog.hide)
                        .then(authentication.fetchMe);
                }

                return $mdDialog.hide().then(function () {

                    return $state.go('checkout', { plan: 'pro' });
                });
            }

            let actionKey = '';
            if ($scope.subscribedOrNonRestrictedSumo) {
                actionKey = $translate.instant('upgrade');
            }
            else {
                actionKey = $translate.instant('subscribe');
            }

            const adminAlert = $mdDialog.alert()
                .title($translate.instant('Please ask an admin to {{action}}', { action: actionKey }))
                .htmlContent('<div>' + $translate.instant('You don\'t have the permissions to {{action}}.', { action: actionKey }) + '</div><div>' + $translate.instant('Please ask a team admin to {{action}} to your desired plan.', { action: actionKey }) + '</div>')
                .multiple(true)
                .ok($translate.instant('Got it'));

            $mdDialog.show(adminAlert);
        };

        $scope.close = function () {

            return $mdDialog.hide(false);
        };

        $scope.goToPlans = function () {

            if (!$scope.currentlyOnPlansPage) {
                if ($window.isMobile) {
                    return $state.go('plans');
                }

                // Open in a new window on desktop
                // Utils will handle the closing of the opened window when done
                // `focusEventListener` handles what happens when we did subscribe in the opened window
                return utils.popup($state.href('plans'), '_blank');
            }
        };

        $scope.getDiscountSavingsText = function () {
            // Use a marker that we replace after translation
            // This preserves proper i18n word order while allowing HTML currency symbols
            const marker = '___CURRENCY___';
            const translated = $translate.instant('Available from {{currencyMarker}}{{amount}} per user per month.', {
                currencyMarker: marker,
                amount: $scope.upgradePlan.price.annually.pricePerMonth
            });
            // Replace marker with actual HTML (currency.html is trusted system content)
            return translated.replace(marker, '<span dir="ltr">' + $scope.currency.html + '</span>');
        };

        $scope.getUpgradeText = function () {

            if (!$scope.upgradePlan) {
                return '';
            }

            return $translate.instant('Upgrade to {{plan}} plan', { plan: $scope.upgradePlan.name });
        };

        $scope.getSubscribeText = function () {

            if (!$scope.upgradePlan) {
                return '';
            }

            return $translate.instant('Subscribe to {{plan}} plan', { plan: $scope.upgradePlan.name });
        };

        function init() {

            // We need this to check if a user came back to this state after subscribing from another tab (via 'compare plans' in upgrade dialog)
            // If the user subscribed this way, reload the state only when on the billing overview, we don't want to lose potentially unsaved work.
            $window.addEventListener('focus', focusEventListener);

            $scope.upgradePlan = plansService.get().pro;

            const selectedFeatureIndex = $scope.upgradePlan.features.findIndex(function (feature) {

                return feature.flag === flag;
            });
            const titles = {
                multiStepWorkflows: $translate.instant('Want to send multi-step email workflows?'),
                permissions: $translate.instant('Want to set permissions?'),
                dashboards: $translate.instant('Want to create custom reports and dashboards?')
            };

            if (flag) {
                $scope.title = titles[flag];
            }

            $scope.sliderConfig = {
                startSlide: selectedFeatureIndex === -1 ? 0 : selectedFeatureIndex,
                draggable: true,
                continuous: true,
                disableScroll: false,
                stopPropagation: false
            };
        }

        function focusEventListener() {

            if (!model.me.team.subscribed) {
                authentication.fetchMe()
                    .then(function () {

                        if (model.me.team.subscribed) {
                            $window.removeEventListener('focus', focusEventListener);

                            $mdDialog.hide().then(function () {

                                if ($state.current.name === 'settings.billingSettings.overview') {
                                    $state.reload();
                                }
                            });
                        }
                    });
            }
        }
    }
})();
